import { render, staticRenderFns } from "./SectionRules.vue?vue&type=template&id=508d8f07"
import script from "./SectionRules.vue?vue&type=script&lang=js"
export * from "./SectionRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports